<template>
  <section>
    <div class="section_title">
      <img src="@/assets/img/cart_sub.jpg" />
      <h1 class="">ご注文</h1>
    </div>
    <h2 class="mb-0 mt-2 text-left">4.最終確認</h2>
    <div class="form-navi my-5">
      <ul class="d-flex flex-wrap">
        <li class="px-3">1.カートを確認</li>
        <li class="px-3">2.お届け先の選択</li>
        <li class="px-3">3.お支払い方法の選択</li>
        <li class="here px-3">4.最終確認</li>
      </ul>
    </div>
  </section>
  <section>
    <div class="detail-cart border box-p-20 mb-5">
      <div class="d-flex py-3 border-bottom only_pc">
        <div class="shohin_group text-center"><p>商品</p></div>
        <div class="shohin_quantity text-center"><p>個数</p></div>
        <div class="shohin_price text-center"><p>価格</p></div>
      </div>
      <!-- 動的HTML生成部 カート商品 -->
      <div id="CartList">
        <ul>
          <li
            v-for="(item, i) in cartItems"
            :key="item.no"
            class="d-flex align-items-center border-bottom"
          >
            <div class="shohin_group d-flex align-items-center my-3">
              <p>{{ i + 1 }}</p>
              <img
                :src="imgHome + item.no + '/thumb.jpg'"
                :alt="item.name"
                @error="noImage"
                class="mx-4"
              />
              <p>{{ item.name }}</p>
            </div>
            <div class="shohin_quantity text-center my-3">
              {{ item.count }}個
            </div>
            <div class="shohin_price my-3">
              <p class="text-right">{{ item.amount }}円</p>
            </div>
          </li>
        </ul>
      </div>
      <div>
        <div class="d-flex my-3">
          <div class="shohin_price_all text-right"><p>小計</p></div>
          <div class="shohin_price text-right">
            <p>{{ totalItems.subTotal }}円</p>
          </div>
        </div>

        <div v-show="totalItems.collectFee" class="style-d-flex my-3">
          <div class="shohin_price_all text-right"><p>代金引換手数料</p></div>
          <div class="shohin_price text-right">
            <p>{{ totalItems.collectFee }}円</p>
          </div>
        </div>

        <div class="d-flex my-3">
          <div class="shohin_price_all text-right"><p>送料</p></div>
          <div class="shohin_price text-right">
            <p>{{ totalItems.carriageFee }}円</p>
          </div>
        </div>
        <div class="d-flex my-3">
          <div class="shohin_price_all text-right"><p>使用ポイント</p></div>
          <div class="shohin_price text-right">
            <p>{{ usePoint }}ポイント</p>
          </div>
        </div>
        <div class="d-flex my-3">
          <div class="shohin_price_all text-right"><p>合計</p></div>
          <div class="shohin_price text-right">
            <p>{{ total }}円</p>
          </div>
        </div>
        <div class="d-flex my-3">
          <div class="shohin_price_all text-right"><p>付与予定ポイント</p></div>
          <div class="shohin_price text-right">
            <p>{{ WillbeCollectedPoint }}ポイント</p>
          </div>
        </div>
      </div>
      <div class="text-center">
        <router-link to="/cart" class="btn d-inline-block mt-5"
          >商品の個数を変更する</router-link
        >
      </div>
    </div>
  </section>
  <section>
    <div class="detail-cart border box-p-20 mb-5">
      <h2 class="text-left mb-5">お届け先住所</h2>
      <div class="form-member my-5">
        <div class="inner">
          <dl id="ShippingAddress">
            <!-- 動的HTML生成部 お届け先 -->
            <dt>
              <strong>{{ addressItems.name }}</strong>
            </dt>
            <dd>
              住所：〒{{ addressItems.zipCode }}&emsp;{{ addressItems.address1
              }}{{ addressItems.address2 }}<br />電話：{{ addressItems.tel }}
            </dd>
          </dl>
        </div>
      </div>
      <div class="text-center mt-3">
        <router-link to="/cart/delivery" class="btn d-inline-block"
          >お届け先住所を変更する</router-link
        >
      </div>
    </div>
  </section>
  <section>
    <div class="detail-cart border box-p-20 mb-5">
      <h2 class="text-left mb-5">お届け指定日</h2>
      <div id="DeliveryDate" class="date box-p-20 border">
        {{ deliveryDate }}
      </div>
      <p>
        ※ご指定のお届け日の場合、<strong>{{ recordedMonth }}</strong
        >月度の実績として計上されます。
      </p>
      <br />
      <div class="text-center mt-3">
        <router-link to="/cart/delivery" class="btn d-inline-block"
          >お届け先住所を変更する</router-link
        >
      </div>
    </div>
  </section>
  <section>
    <div class="detail-cart border box-p-20 mb-5">
      <h2 class="text-left mb-5">お支払方法</h2>
      <div id="Payment" class="date box-p-20 border">{{ paymentName }}</div>
      <br />
      <div class="text-center mt-3">
        <router-link to="/cart/payment" class="btn d-inline-block"
          >お支払方法を変更する</router-link
        >
      </div>
    </div>
  </section>
  <section>
    <div class="detail-cart border box-p-20 mb-5">
      <h2 class="text-left mb-5">返品について</h2>
      <div class="txt-cmn-01">
        <span>返品または商品販売契約の不成立等の伴う返金がある場合、原則申込みをされたご本人名義の預金口座に返金手続きをさせていただきます。</span><br />
        <span>ただし、商品代金をクレジットカードでお支払いの場合は、<br />代金支払の際に利用されたクレジットカード会社からの返金となります。</span>
        <br />
        <br />
        詳しくは以下の項目をご覧ください。
      </div>
      <dl class="list-detail cancel">
        <dt>クーリング・オフに伴う返品</dt>
        <dd>
          会員登録後、会員は、初回購入商品に同梱された契約書面（「会員登録書」「商品購入伝票」及び「会員マニュアル」）を受領した日から20日を経過するまでは、書面により無条件で会員契約の解除（クーリング・オフ）を行うことができます。<br />クーリング・オフがあった場合、既に受領されている商品はご返品いただきますが、その返品に要する費用は当社が負担いたします（着払いにて当社にご返送ください）。また、商品代金をお支払い済みのときには、当社は速やかにその全額を返金いたします。<br />クーリング・オフの手続は書面（はがき等）を当社へ送付することにより行います。<br />書面には
          1：「クーリング・オフ希望」の旨 2：会員番号 3：お名前 4：ご住所
          5：電話番号のご記入とご捺印をお願いします。
        </dd>
        <dt>退会に伴う返品</dt>
        <dd>
          会員登録日から1年以内に退会する場合、未開封品を返品することができます。<br />当該返品商品について支払済の商品代金を返金します。解約申込後5日以内に返品商品をご返送ください。なお、返品の際の送料は会員ご本人の負担となります。
        </dd>
        <dt>その他会員都合の返品</dt>
        <dd>
          商品到着後14日以内であれば、未開封品に限り返品する事ができます。ただし、以下の点にご注意ください。
          <ol class="list-dec-02">
            <li>ツール品のみの返品はお受けできません。</li>
            <li>返品の際の送料は会員ご本人の負担となります。</li>
            <li>
              返品により、同時注文した商品（ツール品を除く）が3個未満になった場合、返品の商品代金から送料差引の上返金します。
            </li>
            <li>頻繁な返品はお受けできない場合があります。</li>
          </ol>
        </dd>
      </dl>
      <p class="txt-cmn-01 mt-5">
        ※返品等に関する事項は【<a
          href="https://docs.google.com/viewer?url=https://www.manavis-cosme.co.jp/web/contents/library/pdf/business-tool/manual_202604.pdf"
          >会員マニュアル</a
        >P15第4項
        クーリング・オフと返品（2）】についても記載がございますので必要に応じてご参照ください。
      </p>
    </div>
  </section>
  
  <section>
    <div class="detail-cart border box-p-20 mb-5" style="background-color: #EBF6F7;">
       ※ご注文を確定される前に、商品名・数量に誤りがないか今一度ご確認をお願いいたします。<br> 
       マナビス化粧品では品質管理を徹底するため、誠に恐れ入りますが、会員様のご都合による返品・交換は原則として承っておりません。 
      </div>
  </section>
  
  <section>
    <div class="detail-cart border box-p-20">
      <!-- 使用していないよう
      <p class="c-check" style="display: none">
        <input id="WantCatlog" type="checkbox" />
        <label for="WantCatlog"
          >商品総合カタログセット１部希望&emsp;（希望の方はチェックしてください）</label
        >
      </p>
      -->

      <p class="c-check">
        <input
          id="WantShippingMail"
          type="checkbox"
          v-model="traceMail"
          true-value="1"
          false-value="0"
        />
        <label for="WantShippingMail"
          >配送追跡メール&emsp;（必要な方はチェックしてください）</label
        >
      </p>
    </div>

    <div class="d-flex justify-content-around text-center column_sp">
      <div v-show="paymentMethod != 3 || payPoint">
        <button @click="orderCommit" class="btn d-inline-block mt-5">
          注文を確定する
        </button>
      </div>

      <!-- ＞佐々木さん クレジット決済の場合のみ表示、カード会社の外部ページへ遷移（警告のダイアログでます）-->
      <div v-show="paymentMethod == 3 && !payPoint">
        <button
          type="submit"
          @click="creditSubmit"
          class="btn d-inline-block my-5"
        >
          クレジットカード情報入力
        </button>
        <form :action="creditUrl" method="post">
          <input type="hidden" name="pay_id" v-model="shopId" />
          <input type="hidden" name="pay_pass" v-model="apiKey" />
          <!-- 顧客ID-->
          <input type="hidden" name="cust_code" v-model="custCode" />
          <!-- 注文番号 -->
          <input type="hidden" name="order_id" v-model="orderNo"/>
          <!-- 氏名-->
          <input type="hidden" name="cust_name" v-model="custName" />
          <!-- 電話番号 -->
          <input type="hidden" name="cust_tell" v-model="tel" id="TelNo" />
          <!-- メールアドレス -->
          <input type="hidden" name="cust_email" v-model="mail" id="MailAddress" />

          <!-- 商品番号 -->
          <input type="hidden" name="item_id" value="0001" />
          <!-- 商品名 -->
          <input type="hidden" name="item_name" value="マナビス化粧品購入商品" />
          <!-- 金額 -->
          <input type="hidden" name="amount" v-model="creditTotal">
          <!-- 消費税-->
          <input type="hidden" name="tax" value="0" />
          <!-- サイトID-->
          <input type="hidden" name="site_id" v-model="siteId" />
          <!-- 支払い種別 -->
          <input type="hidden" name="pay_type" value="1" />
          <!-- 支払い種別 -->
          <input type="hidden" name="pay_method" value="0" />
          <!-- UID -->
          <input type="hidden" name="param1" v-model="uux"/>
          <input type="hidden" name="api_url" v-model="returnURL1">
          <input type="hidden" name="succ_url" v-model="returnURL2">
        </form>
      </div>
    </div>
  </section>
</template>


<script>
import Request from "@/modules/Request";
import Store from "@/modules/Store";
import Message from "@/modules/Message";
import Device from "@/modules/Device";
import Authenticate from "@/modules/Authenticate";
import $ from "jquery";
let request = new Request();
let device = new Device();
let store = new Store();
let auth = new Authenticate();

export default {
  data() {
    return {
      cartItems: [],
      totalItems: {},
      addressItems: {},
      deliveryDate: "",
      recordedMonth: "",
      paymentName: "",
      paymentMethod: "",

      traceMail: "0",

      imgHome: process.env.VUE_APP_CONTENTS_PRODUCT_HOME,

      // クレジット決済に利用する
      pType: "",
      orderNo: "",
      tel: "",
      mail: "",
      uux: "",
      loginInfo:"",
      creditUrl: process.env.VUE_APP_CREDIT_URL,
      shopId: "SPSSFA0000056997",
      apiKey: "cM7ssV!03Xg",
      siteId: "0001",
      custCode: "",
      custName:"",
      returnURL1:process.env.VUE_APP_CREDIT_RETURN_URL1,
      returnURL2:process.env.VUE_APP_CREDIT_RETURN_URL2,

      creditResult: 1,
      pid: new Date().getTime(),
      WillbeCollectedPoint: 0,
      usePoint: 0,
      total: 0,
      isProxy: false,
      creditSubTotal: 0,
      creditTotal:0,
      payPoint: false,
    };
  },
  mounted() {
    window.scroll(0, 0);
    this.getConfirm();
    this.loginInfo = auth.getLoginInfo();
    console.log(this.loginInfo)
    this.custName = auth.loginName();
    this.custCode = this.loginInfo.no;
    this.setPoint();
    if (store.get("isProxy") == "1") {
      this.isProxy = true;
    }

    // クレジット決済用パラメータの決定
    this.pType = device.isMobile() ? 5 : 3;
    $(function () {
      $(".list-detail dt").on("click", function () {
        $(this).toggleClass("is-active");
        $(this).next().slideToggle("fast");
      });
    });
    console.log(this.creditUrl)
  },
  methods: {
    setPoint() {
      
      this.usePoint = store.get("usePoint");
    },
    noImage(event) {
      event.target.src =
        process.env.VUE_APP_CONTENTS_PRODUCT_HOME + "/nothumb.jpg";
    },
    getConfirm() {
      let postParams = [store.get("usePoint")];
      let requestParams = request.createParams(
        "webMdlOrder",
        "getConfirm",
        postParams
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          this.cartItems = data.cartItems;
          this.totalItems = data.totalItems;
          this.addressItems = data.addressItems;
          this.deliveryDate = data.deliveryDate;
          this.recordedMonth = data.recordedMonth;
          this.paymentName = data.paymentName;
          this.WillbeCollectedPoint = data.willbeCollectedPoint;
          this.paymentMethod = data.paymentMethod;
          this.tel = data.tel;
          this.mail = data.mail;
          this.custCode = data.custCode;
          this.total =
            parseInt(this.totalItems.total.replace(",", "")) -
            parseInt(this.usePoint);
          console.log(this.total);
          if (this.total == 0) this.payPoint = true;
          if (this.usePoint > 0) {
            console.log("ポイント使用");
            this.paymentName += "(ポイント使用)";
          }
          if (this.total == 0) {
            console.log("ポイント購入");
            this.paymentName = "ポイント購入";
          }
          this.total = this.total.toLocaleString();
          this.creditTotal = this.total.replace(",", "");
          this.creditSubTotal =
            parseInt(this.totalItems.creditSubTotal.replace(",", "")) -
            parseInt(this.usePoint);
        });
    },
    orderCommit() {
      Message.confirm()
        .fire({
          title: "入力頂いた内容で注文を確定します。よろしいですか？",
        })
        .then((result) => {
          if (result.isConfirmed) {
            let postParams = [0, this.traceMail, this.usePoint, this.payPoint];
            let requestParams = request.createParams(
              "webMdlOrder",
              "putOrder",
              postParams
            );
            request
              .create()
              .post("", requestParams)
              .then(() => {
                store.remove("isProxy");
                this.$router.push("/cart/complete");
              });
          }
        });
    },
    creditSubmit() {
      Message.confirm()
        .fire({
          title: "カード会社のサイトへ移動します。よろしいですか？",
        })
        .then((result) => {
          if (result.isConfirmed) {
            let postParams = [0, this.traceMail, this.usePoint, this.payPoint];
            let requestParams = request.createParams(
              "webMdlOrder",
              "putOrder",
              postParams
            );
            request
              .create()
              .post("", requestParams)
              .then((data) => {
                this.uux = data.Uux;
                this.orderNo = data.OrderNumber;
                this.$nextTick(() => {
                  document.forms[0].submit();
                });
              });
          }
        });
    },
  },
};
</script>
